import axios from 'axios';
import type { PMAppliedLesson } from '@/models/pmappliedlesson';
import type { PMPhase } from '@/models/pmphase';
import type { ProjectUser } from '@/models/projectUser';
import type { Project } from '@/models/project';
import type { PMSubPhase } from '@/models/pmsubphase';

class PMAppliedLessonWebservice {
    public getByWorksheetId(pmWorksheetId: number) {
        return axios.get('/pmappliedlessons/getByWorksheetId', {
            params: {
                pmWorksheetId,
            },
        });
    }

    public update(appliedLesson: PMAppliedLesson) {
        return axios.post('/pmappliedlessons/update', {
            ...appliedLesson,
        });
    }

    public store(pmWorksheetId: number, pmAppliedLessons: PMAppliedLesson[], pmNewAppliedLessons: PMAppliedLesson[]) {
        return axios.post('/pmappliedlessons/store', {
            pmWorksheetId,
            pmAppliedLessons,
            pmNewAppliedLessons,
        });
    }

    public updateAppliedLessonAndLesson(
        appliedLesson: PMAppliedLesson,
        lesson: { insight: string; project_only: boolean; sub_phase: PMSubPhase }
    ) {
        return axios.post('/pmappliedlessons/updatePmAppliedLessonAndPmLesson', {
            id: appliedLesson.id,
            dynamic_field: appliedLesson.dynamic_field,
            contacttill: appliedLesson.contacttill,
            external_responsible_user: appliedLesson.external_responsible_user,
            internal_responsible_user: appliedLesson.internal_responsible_user,
            responsible_user: appliedLesson.responsible_user,
            todo: appliedLesson.todo,
            solution: appliedLesson.solution,
            lesson: {
                insight: lesson.insight,
                project_only: lesson.project_only,
                sub_phase: lesson.sub_phase,
            },
        });
    }

    public getToDos() {
        return axios.get('/pmappliedlessons/getToDos');
    }

    public getProjectOpenTasks(
        selectedPMPhases: PMPhase[],
        selectedResponsibleUsers: ProjectUser[],
        selectedProject: Project
    ) {
        return axios.post('/pmappliedlessons/getProjectOpenTasks', {
            pm_phases_ids: selectedPMPhases.map((el) => el.id),
            responsible_users: selectedResponsibleUsers,
            project_id: selectedProject.id,
        });
    }

    public emailTheOpenTasks(
        selectedPMPhases: PMPhase[],
        selectedResponsibleUsers: ProjectUser[],
        selectedProject: Project
    ) {
        return axios.post('/pmappliedlessons/emailTheOpenTasks', {
            pm_phases_ids: selectedPMPhases.map((el) => el.id),
            responsible_users: selectedResponsibleUsers,
            project_id: selectedProject.id,
        });
    }

    public remove(id: number) {
        return axios.delete('/pmappliedlessons/remove', {
            params: { id },
        });
    }
}

export const pmAppliedLessonWebservice = new PMAppliedLessonWebservice();
